module.exports = __webpack_public_path__ + "static/example_week_grid-108b120ff54a7f338fa68747699c196c.png";